
const VocabInstructionsPrescription = {
    'instructions_prescription_tittle' : ['Cómo redactar instrucciones.', 'How to write instructions.',],

    'example_sentence_arr' : [
        ['1)', 'Paracetamol ', '- ', 'Tomar ', '1/2 ', 'pastilla ', 'cada ', '24 ', 'horas, ', 
            'vía oral ', 'durante ', '1 semana', '; ', 'Acompañar con alimentos.'], 
        [],
    ],

    'pharmaceutical_form' : ['Forma farmacéutica', 'pharmaceutical form',],
    'pharmaceutical_form_description' : ['Forma farmacéutica', 'pharmaceutical form',],

    'numeration' : ['1)', '1)',],
    'numeration_description' : [': Numeración ascendente seguida de paréntesis.', 'Paracetamol',],

    'drug' : ['Paracetamol', 'Paracetamol',],
    'drug_description' : [': Fármaco', 'Drug',],

    'hyphen' : ['-', '-',],
    'hyphen_description' : [': Añade un guión después del fármaco', 'hyphen_description',],
    
    'verb' : ['Tomar', 'Take',],
    'verb_description' : [': Verbo a realizar por el paciente.', 'verb_description',],

    'number_drug' : ['1/2', 'Drug number'],
    'number_drug_description' : [': Número del fármaco a recetar.', 'number_drug_description'],
    'unit_drug' : ['pastilla', 'Drug unit'],
    'unit_drug_description' : [': Unidad de medida del fármaco.', 'unit_drug_description',],

    'conjunction' : ['cada', 'every',],
    'conjunction_description' : [': Conjunción uniendo cantidad y periodicidad.', 'conjunction_description',],
    
    'number_peropdicity' : ['24', '34'],
    'number_peropdicity_description' : [': Número de la periodicidad a seguir.', 'number_peropdicity_description'],
    'peropdicity_unit' : ['horas', 'hours'],
    'peropdicity_unit_description' : [': Unidad de tiempo de la periodicidad.', 'peropdicity_unit_description',],

    'route_of_administration' : ['vía oral', 'route of administration',],
    'route_of_administration_description' : [': Vía de administración', 'route_of_administration_description',],

    'preposition' : ['durante', 'Preposition',],
    'preposition_description' : [': Preposición uniendo vía y duración.', 'preposition_description',],

    'number_duration' : ['1', '4'],
    'number_duration_description' : [' : Número de duración de tratamiento.', 'number_duration_description'],
    'unit_duration' : ['semana', 'Time unit (duration)',],
    'unit_duration_description' : [': Unidad de tiempo de la duración. ', 'unit_duration_description',],

    'semicolon' : ['Punto y coma', 'Semicolon',],
    'semicolon_description' : [': Añade punto y coma para añadir indicaciones.', 'semicolon_description',],

    'indication_of_use' : ['Acompañar con alimentos', 'Indication of use',],
    'indication_of_use_description' : [': Indicaciones de uso.', 'indication_of_use_description',],

    'note_on_quantitites' : ['Es posible usar números decimales y fraccionarios para fármacos.', 'number_note',],

  }
  export default VocabInstructionsPrescription;
    